    <mat-checkbox [formControl]="control">  {{label}}</mat-checkbox>